export const orderRiskTagListRoutes = {
    path: '',
    name: 'orderRiskTag',
    component: () => import('@/views/orderRiskTag/index.vue'),
    meta: {
      hidden: false,
      title: 'Order Risk Tag'
    }
  }
  
  
  
  